<template>
  <div>
    <input type="text" v-model="email" />
    <input type="password" v-model="password" />
    <button @click="login">Login</button>
  </div>
</template>

<script>
export default {
  name: 'Login',

  data() {
    return {
      email: '',
      password: '',
    };
  },

  methods: {
    login() {
      axios.get('/sanctum/csrf-cookie').then(response => {
        axios
          .post('login', {
            email: this.email,
            password: this.password,
          })
          .then(response => {
            if (response.status === 204) {
              window.location.href = '/backend';
            }
          });
      });
    },
  },
};
</script>

<style scoped>
input {
  color: black;
}
</style>
